import { Box, Typography } from "@mui/material";
import { AutoAwesome as SparklesIcon } from "@mui/icons-material";
import { useTranslationApp } from "../../../lib/i18next";
import { MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE, MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE } from "../../../i18n/keysTranslations";

const EmptyState = () => {
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: 400,
      }}
    >
      <Box sx={{ textAlign: "center", maxWidth: 400 }}>
        <Box
          sx={{
            p: 3,
            bgcolor: "grey.100",
            borderRadius: "50%",
            width: "fit-content",
            mx: "auto",
            mb: 2,
          }}
        >
          <SparklesIcon sx={{ fontSize: 48, color: "text.secondary" }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          {t(MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE)}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t(MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE)}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyState;
